export default "__VITE_PUBLIC_ASSET__68cb8a98__"